import React from 'react'
import Images from '../../../assets/Images'
import { useNavigate } from 'react-router'
import atoms from '../../atoms'
import { priceTagFormatter } from '../../../constants/utils'
import { useDispatch, useSelector } from 'react-redux'
import { setPageLimit } from '../../../features/productList/pageCount/pageCount'
import { setPreviousListLocation } from '../../../features/productList/listLocation/listLocation'
import { RootState } from '../../../store/store'
import constant from '../../../constants/constant'
import { useMediaQuery } from 'react-responsive';
import ProductCardDetail from './productCartDetail'

const { CoverImage } = Images
const { AvailableBadge, CustomImages } = atoms
const Index = ({ productData }: any) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isMobile = useMediaQuery({ query:'(max-width: 768px)' });
    const isMediumScreen = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1024px)' });

    const reduxPageCount = useSelector((state: RootState) => state?.rootReducer?.pageCount);
    const reduxLimitPerPage = useSelector((state: RootState) => state?.rootReducer.pageCount.limit)
    const reduxProductListLocation = useSelector((state: RootState) => state?.rootReducer?.listLocation);


    const handleClick = () => {
        navigate(`/product/details/${productData?.id}`)
        dispatch(setPageLimit(reduxLimitPerPage * reduxPageCount?.pageCount))
        dispatch(setPreviousListLocation(reduxProductListLocation?.listLocation))
    }

    const badgeTitle = productData?.available_at_store ? "Available At Store"
        : productData?.available_at_other_store ? 'Available At Branch'
            : `Available in:  ${productData?.transit_days}`

    const badgeStyle = productData?.available_at_store ? "available"
        : productData?.available_at_other_store ? 'otherunavailable'
            : 'unavailable'

    const notShowBadge: boolean = !productData?.available_at_store ?
        (productData?.available_at_other_store ? true :
            productData?.transit_days !== constant.Product_Transit_Days_Undefined) : true;

    const imageHeight = (): string => {
        if (isMobile) {
            return '60px';
        } else if (isMediumScreen) {
            return '80px';
        } else {
            return '200px';
        }
    }


    return (
        <div className="col-6 col-md-4 mt-2">
            <div className='product-card position-relative' onClick={() => handleClick()}>
                {notShowBadge && <div className="product-card-badge">
                    <AvailableBadge title={badgeTitle} style={badgeStyle} />
                </div>}
                <CustomImages className='product-img' imageHeight={imageHeight()} src={productData?.images[0] || CoverImage} />
                <ProductCardDetail productData={productData}/>
                {/* <div className={`${window.innerWidth < 876 && 'row'}`}>
                    <div className='col-md-12 col-7 d-md-flex flex-wrap justify-content-between align-items-md-center mt-md-4 mt-2'>
                        <h2 className="fs-md-16 fs-10 mb-0 fw-700">{productData?.brand?.brand_name}</h2>
                        <h2 className="fs-md-14 fs-10 mb-0 mt-2 mt-md-0 fw-600 d-none d-md-block ">{priceTagFormatter(productData?.product_srp)}</h2>
                        <h2 className="fs-md-14 fs-10 mb-0 mt-2 mt-md-0 fw-600 d-md-none">{productData?.modal_number}</h2>
                    </div>
                    <div className='col-md-12 col-5 d-sm-none'>
                        <h2 className='fs-12 fw-600 px-0 mx-0 my-2'> {priceTagFormatter(productData?.product_srp)}</h2>
                    </div>

                    <div className='col-md-12 col-sm-5 col-12 d-none d-md-flex flex-wrap justify-content-between align-items-md-center'>
                        {!productData?.is_contact_lens && <h2 className='d-none d-md-flex fs-12 fw-500 my-2'>{window.innerWidth > 768 && "Model No:"}<span> {productData?.modal_number} </span></h2>}
                        {productData?.is_contact_lens && <h2 className='d-none d-lg-flex fs-12 fw-500 my-2'>Lens Name: <span>{productData?.lens_name}</span></h2>}
                        {productData?.is_contact_lens && <h2 className='d-none d-lg-flex fs-12 fw-500 my-2'>Color: <span>{productData?.color?.color_name}</span></h2>}
                    </div>

                    <div className='d-none d-lg-flex mt-1 mt-lg-0 justify-content-between align-items-center'>
                        <h2 className={`mb-0 fs-12 fw-500 ${productData?.is_contact_lens ? 'invisible' : ''}`}>Size/Power: <span>{productData?.glass_size}MM</span></h2>
                        <h2 className={`mb-0 fs-12 fw-500 ${productData?.is_contact_lens ? 'invisible' : ''}`}>Color: <span>{productData?.brand_color_code}</span></h2>
                    </div>
                </div> */}
            </div>
        </div >
    )
}

export default Index